import React, { useState, useEffect } from "react";
import { Button, Form, Input, Spin, notification } from "antd";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import Cookies from "js-cookie";

const StyledDiv = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #0095c580;
`;

const Logo = styled.img`
  height: auto;
  width: 160px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const importAll = (r) => {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

const images = importAll(
  require.context("../../images", false, /\.(png|jpe?g|svg)$/)
);

const Login = () => {
  const history = useHistory();
  const [btnLoading, setBtnLoading] = useState(false);

  const handleFormSubmit = (values) => {
    const { username, password } = values;
    setBtnLoading(true);
    let formData = new FormData();
    formData.append("Username", username);
    formData.append("Password", password);

    axios("/api/Account/Login", {
      method: "POST",
      data: formData,
    })
      .then((response) => {
        setBtnLoading(false);
        const { data } = response;
        if (data && data.role) {
          Cookies.set("role", data.role);
          history.push("/events");
        }
      })
      .catch((err) => {
        setBtnLoading(false);
        notification.error({
          message: "Error",
          description: "Failed to login!",
        });
        console.log(err);
      });
  };
  return (
    <StyledDiv>
      <div className="form-wrapper" style={{ padding: "40px 40px 0px" }}>
        <Logo src={images["logo.png"]} />
        <Form onFinish={handleFormSubmit} requiredMark={false}>
          <Form.Item
            name="username"
            label="Username"
            rules={[
              {
                required: true,
                message: "Please input username!",
              },
            ]}
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: "Please input password!",
              },
            ]}
            labelCol={{ span: 24 }}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item wrapperCol={{ lg: { offset: 10 } }}>
            <Button
              className="submitBtn"
              loading={btnLoading}
              type="primary"
              htmlType="submit"
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </div>
    </StyledDiv>
  );
};

export default Login;
